import useSWR from "swr";
import { useSearchParams } from "react-router-dom";

import { useApiAccess } from "./useApiAccess";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { getParticularArticle } from "../../Service/ArticleService";

export const useArticle = ({ articleSlug }) => {

    const hasAccess = useApiAccess();
    const [ searchParams ] = useSearchParams();
    const productParam = searchParams.get('product');

    const pathParams = {
        ...(productParam && { product: productParam }),
    };

    return useSWR(
        hasAccess ? `${apiRoutes.getParticularArticle}${articleSlug}${productParam}` : null,
        () => getParticularArticle( articleSlug, pathParams)
    );
}